import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cloudStandard: {
    id: 'WacSignupHeader.cloudStandard',
    defaultMessage: 'Cloud Standard'
  },
  cloudPremium: {
    id: 'WacSignupHeader.cloudPremium',
    defaultMessage: 'Cloud Premium'
  },
  cloudFree: {
    id: 'WacSignupHeader.cloudFree',
    defaultMessage: 'Cloud Free'
  }
});
